import {captureMessage} from '@sentry/browser';
import {showNotification} from 'platform/components';

import {isRunningInCypress} from 'shared/web';

const isDev = process.env.ENV_TYPE === 'dev';
const isStage = process.env.ENV_TYPE === 'stage';
const isE2E = isRunningInCypress();

/**
 * Logs an error message based on environment type.
 * In dev/stage environments, logs to console and shows notification.
 * In production, sends error to Sentry.
 * @param errorMessage - The error message to log
 */
export function logError(errorMessage: string) {
  if (isDev || isStage || isE2E) {
    console.error(errorMessage);

    showNotification.error(errorMessage);

    return;
  }

  captureMessage('updatePreset', (scope) =>
    scope.setLevel('error').setExtras({
      userDescription: errorMessage,
    })
  );
}
